import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';

import { EsnJobOfferRoutingModule } from './esn-job-offer-routing.module';
import { ListOffersComponent } from './components/list-offers/list-offers.component';
import { SuggestionOffersComponent } from './components/suggestion-offers/suggestion-offers.component';
import { DetailsOfferComponent } from './components/details-offer/details-offer.component';
import { ArchivedEsnOfferComponent } from './components/archived-esn-offer/archived-esn-offer.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PaginationModule } from './../../shared/components/pagination/pagination.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ListOffersCandidatureComponent } from './components/list-offers-candidature/list-offers-candidature.component';
import { DetailOfferCandidatureComponent } from './components/detail-offer-candidature/detail-offer-candidature.component';
import { ContactlistofferComponent } from './components/contactlistoffer/contactlistoffer.component';
import { FieldErrorModule } from './../../shared/components/shared-field-error/field-error.module';
import { QuillModule } from 'ngx-quill';
import { CalendarModule } from 'primeng/calendar';
import localeFr from '@angular/common/locales/fr';
import { SharedModule } from 'app/shared/shared.module';
import { MatMenuModule } from '@angular/material/menu';
@NgModule({
  declarations: [
    ListOffersComponent,
    SuggestionOffersComponent,
    DetailsOfferComponent,
    ArchivedEsnOfferComponent,
    ListOffersCandidatureComponent,
    DetailOfferCandidatureComponent,
    ContactlistofferComponent,
  ],
  imports: [
    CommonModule,
    EsnJobOfferRoutingModule,
    NgxSpinnerModule,
    PaginationModule,
    ReactiveFormsModule,
    NgSelectModule,
    CalendarModule,
    FieldErrorModule,
    SharedModule,
    MatMenuModule,
    QuillModule.forRoot({
      modules: {
        syntax: true,
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'], // toggled buttons
          ['blockquote', 'code-block'],

          [{ header: 1 }, { header: 2 }], // custom button values
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
          [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
          [{ direction: 'rtl' }], // text direction

          [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
          [{ header: [1, 2, 3, 4, 5, 6, false] }],

          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ font: [] }],
          [{ align: [] }],

          ['clean'], // remove formatting button
        ],
      },
    }),
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'fr-FR' }]
})
export class EsnJobOfferModule {
  constructor() {
    registerLocaleData(localeFr);
  }
}
